import React, { useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
// import { all_routes } from "../../../Router/all_routes";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL, SIGN_IN_DETAILS } from "../../../Config";

const Signin = () => {
  // const route = all_routes;

  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");

    try {
      const trimmedUsername = formData.username.replace(/\s/g, "");
      const trimmedPassword = formData.password.replace(/\s/g, "");
      const response = await fetch(`${API_BASE_URL}${SIGN_IN_DETAILS}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Name: trimmedUsername,
          Password: trimmedPassword,
        }),
      });

      const data = await response.json();
      console.log | data;

      if (data.Status && data.ResultData && data.ResultData.length > 0) {
        sessionStorage.clear();
        localStorage.clear();
        sessionStorage.setItem(
          "userData",
          JSON.stringify(data["ResultData"][0])
        );
        setLoading(false);
        if (data.ResultData[0].InitialPath != null) {
          navigate(`/${data.ResultData[0].InitialPath}`, { replace: true });
          window.location.reload();
        } else {
          navigate("/product-list",{replace:true});
          window.location.reload();
        }
      } else {
        setLoading(false);
        setErrorMessage("*Invalid Credentials..!");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error during fetch:", error);
      setErrorMessage("*An error occurred. Please try again.");
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrorMessage("");
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper bg-img">
          <div className="login-content ">
            <form onSubmit={handleSubmit}>
              <div className="login-userset">
                <div className="login-logo logo-normal">
                  <ImageWithBasePath
                    src={`assets/img/iBizAccounts.png`}
                    alt="img"
                  />
                </div>
                <div className="login-userheading">
                  <h3>Sign In</h3>
                  <h4>
                    Perennial POS application has features that helps you to
                    build <br />
                    solid relationships with customers, track sales activities,
                    <br />
                    automate and keep sales processes stremlined.
                  </h4>
                </div>
                <div className="form-login mb-3">
                  <label className="form-label">User Name</label>
                  <div className="form-addons position-relative">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter username"
                      name="username"
                      value={formData.username}
                      onChange={handleChange}
                      required
                      // onCopy={(e) => e.preventDefault()}
                      // onPaste={(e) => e.preventDefault()}
                      // autoComplete="off"
                    />
                    <i
                      className="fa-regular fa-user position-absolute end-0 me-3"
                      style={{ top: "50%", transform: "translateY(-50%)" }}
                    ></i>
                  </div>
                </div>
                <div className="form-login mb-3">
                  <label className="form-label">Password</label>
                  <div className="pass-group position-relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="pass-input form-control"
                      placeholder="Enter password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                      // onCopy={(e) => e.preventDefault()}
                      // onPaste={(e) => e.preventDefault()}
                      // autoComplete="off"
                    />
                    <span
                      className={`fas toggle-password ${
                        showPassword ? "fa-eye" : "fa-eye-slash"
                      }`}
                      onClick={handleTogglePasswordVisibility}
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        top: "50%",
                        right: "10px",
                        transform: "translateY(-50%)",
                      }}
                    />
                  </div>
                </div>
                <div className="form-login authentication-check">
                  <div className="row">
                    <div className="col-12 d-flex align-items-center justify-content-between">
                      <div className="custom-control custom-checkbox">
                        <label className="checkboxs ps-4 mb-0 pb-0 line-height-1">
                          <input type="checkbox" className="form-control" />
                          <span className="checkmarks" />
                          Remember me
                        </label>
                      </div>
                      <div className="text-end">
                        <Link
                          className="forgot-link"
                          style={{ cursor: "not-allowed" }}
                        >
                          Forgot Password?
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <p className="text-danger fw-bold">{errorMessage}</p>
                <div className="form-login">
                  <button type="submit" className="btn btn-login">
                    {loading ? "Signing in..." : "Sign In"}
                  </button>
                </div>
                <div className="signinform">
                  <h4>
                    New on our platform?
                    <Link to="/" className="hover-a">
                  
                      Create an account
                    </Link>
                  </h4>
                </div>
                <div className="form-sociallink">
                  <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                    <p>
                      Copyright © 2024{" "}
                      <a
                        href="http://www.perennialcode.com/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Perennialcode.
                      </a>
                      All rights reserved
                    </p>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signin;
